/**
 * header.js — wirtschaft. am markt
 * ---------------------------------------------------------------------------
 * Nav behaviour for the fixed top bar:
 *   - hamburger toggles the full green menu overlay (.is-open)
 *   - scrolling past the top tints the bar (.is-scrolled)
 * Scroll locking mirrors the mini-cart pattern (Lenis-aware).
 */

(() => {
  "use strict";

  var header = document.querySelector("[data-site-header]");
  if (!header) return;

  var toggle = header.querySelector("[data-menu-toggle]");
  var overlay = header.querySelector("[data-menu-overlay]");
  if (!toggle || !overlay) return;

  function lockScroll() {
    if (window.lenis) window.lenis.stop();
    else document.documentElement.style.overflow = "hidden";
  }

  function unlockScroll() {
    if (window.lenis) window.lenis.start();
    else document.documentElement.style.overflow = "";
  }

  function setOpen(open) {
    header.classList.toggle("is-open", open);
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    var label = open ? toggle.getAttribute("data-label-close") : toggle.getAttribute("data-label-open");
    if (label) toggle.setAttribute("aria-label", label);
    if (open) lockScroll();
    else unlockScroll();
  }

  function isOpen() {
    return header.classList.contains("is-open");
  }

  toggle.addEventListener("click", function () {
    setOpen(!isOpen());
  });

  // Following a menu link closes the overlay (relevant for same-page anchors).
  overlay.addEventListener("click", function (event) {
    if (event.target.closest("a")) setOpen(false);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && isOpen()) {
      setOpen(false);
      toggle.focus();
    }
  });

  /* ---- Scrolled state --------------------------------------------------- */
  var scrolled = false;

  function onScroll() {
    var next = window.scrollY > 8;
    if (next !== scrolled) {
      scrolled = next;
      header.classList.toggle("is-scrolled", scrolled);
    }
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
})();
